import CrmMapping from "./CrmMapping";

export default CrmMapping;
